module.exports = __webpack_public_path__ + "static/media/learn.9131637b.svg";